import React from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useFiltersStore } from '../state/filtersStore'
import { useNavigationStore } from '../state/navigationStore'
import { Modal } from './Modal'
import { Wizard } from './Wizard'

const WizardModal = () => {
  const { wizardOpen, setWizardOpen, screen } = useNavigationStore(
    useShallow((state) => ({
      wizardOpen: state.wizardOpen,
      setWizardOpen: state.setWizardOpen,
      screen: state.screen,
    }))
  )

  const { selectPreviousGuideFilter, isFirstVisible } = useFiltersStore(
    useShallow((state) => ({
      selectPreviousGuideFilter: state.selectPreviousGuideFilter,
      isFirstVisible: state.isSelectedFilterFirstVisible(),
    }))
  )

  return wizardOpen && screen === 'list' ? (
    <Modal
      faIcon='fa-wand-magic-sparkles'
      title='Smart Guide'
      onClose={() => {
        setWizardOpen(false)
      }}
      onBack={selectPreviousGuideFilter}
      renderBackButton
      visiblyHideBackButton={isFirstVisible}
    >
      <Wizard inModal />
    </Modal>
  ) : null
}

export { WizardModal }
